var TIMEOUT = 2000;
export function onClick(parent) {
    var input = parent.querySelector('input');
    if (!navigator.clipboard) {
        if (copyWithSelection(input)) {
            showClicked(parent);
        }
        return;
    }
    navigator.clipboard.writeText(input.value)
        .then(function () { return showClicked(parent); })
        // браузер может запретить запись в буфер обмена (например, Firefox на старых системах) — копируем через выделение
        .catch(function () {
        if (copyWithSelection(input)) {
            showClicked(parent);
        }
    });
}
/**
 * Выделяет текст поля и копирует его; если копирование не удалось, текст остаётся выделенным для ручного копирования
 */
function copyWithSelection(input) {
    input.select();
    try {
        return document.execCommand('copy');
    }
    catch (_a) {
        return false;
    }
}
function showClicked(el) {
    el.classList.add('clicked');
    if (el.dataset.timeout) {
        clearTimeout(el.dataset.timeout);
    }
    el.dataset.timeout = setTimeout(function () {
        el.classList.remove('clicked');
        delete el.dataset.timeout;
    }, TIMEOUT).toString();
}
export default function initClickToCopy(selector) {
    document.querySelectorAll(selector)
        .forEach(function (copyBox) { return copyBox.addEventListener('click', function () { return onClick(copyBox); }); });
}
